<template>
  <Layout>
    <div>
      <!-- Program Himpunan dan Penyaluran -->
      <section class="page-section program-himpunan-wrapper">
        <div class="container">
          <div class="section-title text-center">
            Download Sekarang
          </div>
          <div class="row justify-content-center mb-5">
            <div class="col-md-8 text-center">
              <a
                href="https://play.google.com/store/apps/details?id=id.masjed.app"
                target="_blank"
              >
                <img
                  class="img-playstore"
                  :src="'img/playstore.png'"
                  alt="Playstore"
                />
              </a>
              <a
                href="https://apps.apple.com/id/app/masjed/id1609918324"
                target="_blank"
              >
                <img
                  class="img-appstore"
                  :src="'img/appstore.png'"
                  alt="AppStore"
                />
              </a>
            </div>
          </div>
          <div class="section-title text-center">
            Program Himpunan <br class="d-block d-md-none" />dan Penyaluran
          </div>
          <div class="text-center">
            <p>
              Dari Abu Hurairah Radhiyallahu ‘Anha -semoga Allah meridhainya- ia
              berkata Rasulullah Shallallahu ‘Alaihi wa Sallam bersabda:
              <br class="d-none d-md-block" />
              <span class="italic"
                >"Apabila salah seorang dari kalian memperbagus keislamannya,
                maka setiap kebaikan yang ia amalkan ditulis untuknya 10 kali
                lipat
                <br class="d-none d-md-block" />
                sampai 700 kali lipat. Dan setiap keburukan yang ia amalkan
                ditulis sama dengannya."</span
              >
            </p>
            <a
              href="#modal-program-1"
              class="program-container-home"
              data-bs-toggle="modal"
            >
              <img :src="'img/img-program-1.svg'" alt="Image" />
              <div class="program-content-home">
                <div class="fs-14 mb-8">Program</div>
                <div class="bold">Infrastruktur Masjed</div>
              </div>
            </a>
            <a
              href="#modal-program-2"
              class="program-container-home"
              data-bs-toggle="modal"
            >
              <img :src="'/img/img-program-2.svg'" alt="Image" />
              <div class="program-content-home">
                <div class="fs-14 mb-8">Program</div>
                <div class="bold">Fasilitas Masjed</div>
              </div>
            </a>
            <a
              href="#modal-program-3"
              class="program-container-home"
              data-bs-toggle="modal"
            >
              <img :src="'/img/img-program-3.svg'" alt="Image" />
              <div class="program-content-home">
                <div class="fs-14 mb-8">Program</div>
                <div class="bold">Sosial & Keumatan</div>
              </div>
            </a>
            <a
              href="#modal-program-4"
              class="program-container-home"
              data-bs-toggle="modal"
            >
              <img :src="'img/img-program-4.svg'" alt="Image" />
              <div class="program-content-home">
                <div class="fs-14 mb-8">Program</div>
                <div class="bold">Pemberdayaan Ekonomi</div>
              </div>
            </a>
            <a
              href="#modal-program-5"
              class="program-container-home"
              data-bs-toggle="modal"
            >
              <img :src="'/img/img-program-5.svg'" alt="Image" />
              <div class="program-content-home">
                <div class="fs-14 mb-8">Program</div>
                <div class="bold">Pendidikan & Dakwah</div>
              </div>
            </a>
            <a
              href="#modal-program-6"
              class="program-container-home"
              data-bs-toggle="modal"
            >
              <img :src="'/img/img-program-6.svg'" alt="Image" />
              <div class="program-content-home">
                <div class="fs-14 mb-8">Program</div>
                <div class="bold">Lingkungan Masjed</div>
              </div>
            </a>
            <a
              href="#modal-program-7"
              class="program-container-home"
              data-bs-toggle="modal"
            >
              <img :src="'/img/img-program-7.svg'" alt="Image" />
              <div class="program-content-home">
                <div class="fs-14 mb-8">Program</div>
                <div class="bold">Kesejahteraan Masjed</div>
              </div>
            </a>
          </div>
          <div class="text-center mt-32">
            <a
              :href="link.program"
              class="btn btn-main d-block d-md-inline-block btn-wide"
              >Program Lainnya</a
            >
          </div>
        </div>
      </section>

      <!-- Modal Infra -->
      <div
        class="modal fade program-modal"
        id="modal-program-1"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div
          class="
          modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl
        "
        >
          <div class="modal-content">
            <div class="modal-body">
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-x-lg"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z"
                  />
                </svg>
              </button>
              <div class="row">
                <div class="col-lg-4 valign-wrapper">
                  <div class="valign-box">
                    <img src="/img/img-program-1.svg" />
                  </div>
                </div>
                <div class="col-lg-8 valign-wrapper">
                  <div class="valign-box">
                    <div class="program-subtitle-modal">Program</div>
                    <div class="program-title-modal">Infrastruktur Masjed</div>
                    <p class="no-margin">
                      Jangan biarkan masjed tidak terawat, rusak, dan
                      terbengkalai. Mari kita wujudkan perbaikan dan pembangunan
                      infrastruktur masjed yang bertujuan untuk memaksimalkan
                      kegiatan beribadah.
                    </p>
                    <div class="row mt-3">
                      <div class="col-12 col-md-12">
                        <div class="form-nominal">
                          <div
                            class="nominal-wrapper"
                            :class="{
                              'is-picked': this.nominalSedekah === 10000,
                            }"
                            @click="setNominal(10000)"
                          >
                            <div class="nominal">Rp. 10.000</div>
                          </div>
                          <div
                            class="nominal-wrapper"
                            :class="{
                              'is-picked': this.nominalSedekah === 20000,
                            }"
                            @click="setNominal(20000)"
                          >
                            <div class="nominal">Rp. 20.000</div>
                          </div>
                          <div
                            class="nominal-wrapper"
                            :class="{
                              'is-picked': this.nominalSedekah === 50000,
                            }"
                            @click="setNominal(50000)"
                          >
                            <div class="nominal">Rp. 50.000</div>
                          </div>
                          <div
                            class="nominal-wrapper"
                            :class="{
                              'is-picked': this.nominalSedekah === 100000,
                            }"
                            @click="setNominal(100000)"
                          >
                            <div class="nominal">Rp. 100.000</div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 mt-3">
                        <div class="form-group">
                          <label for="email">Nominal Donasi</label>
                          <vue-numeric
                            placeholder="Masukan Nominal"
                            class="form-control"
                            currency="Rp."
                            separator="."
                            v-model="this.nominalSedekah"
                          ></vue-numeric>
                        </div>
                      </div>
                    </div>
                    <center>
                      <a
                        href="javascript:void(0)"
                        class="
                      btn btn-main btn-wide
                      d-block d-md-inline-block
                      mt-32
                    "
                        @click="danaiSekarang('infrastruktur-masjed')"
                        >Danai Sekarang</a
                      >
                    </center>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="modal fade program-modal"
        id="modal-program-2"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div
          class="
          modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl
        "
        >
          <div class="modal-content">
            <div class="modal-body">
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-x-lg"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z"
                  />
                </svg>
              </button>
              <div class="row">
                <div class="col-lg-4 valign-wrapper">
                  <div class="valign-box">
                    <img src="/img/img-program-2.svg" />
                  </div>
                </div>
                <div class="col-lg-8 valign-wrapper">
                  <div class="valign-box">
                    <div class="program-subtitle-modal">Program</div>
                    <div class="program-title-modal">Fasilitas Masjed</div>
                    <p class="no-margin">
                      Membantu mewujudkan fasilitas masjed yang dapat
                      dimanfaatkan secara langsung oleh jamaah, sehingga
                      beribadah menjadi lebih khusyu. Harapan kami dalam program
                      ini bisa membantu sebanyak banyaknya masjed yang
                      membutuhkan.
                    </p>
                    <div class="row mt-3">
                      <div class="col-12 col-md-12">
                        <div class="form-nominal">
                          <div
                            class="nominal-wrapper"
                            :class="{
                              'is-picked': this.nominalSedekah === 10000,
                            }"
                            @click="setNominal(10000)"
                          >
                            <div class="nominal">Rp. 10.000</div>
                          </div>
                          <div
                            class="nominal-wrapper"
                            :class="{
                              'is-picked': this.nominalSedekah === 20000,
                            }"
                            @click="setNominal(20000)"
                          >
                            <div class="nominal">Rp. 20.000</div>
                          </div>
                          <div
                            class="nominal-wrapper"
                            :class="{
                              'is-picked': this.nominalSedekah === 50000,
                            }"
                            @click="setNominal(50000)"
                          >
                            <div class="nominal">Rp. 50.000</div>
                          </div>
                          <div
                            class="nominal-wrapper"
                            :class="{
                              'is-picked': this.nominalSedekah === 100000,
                            }"
                            @click="setNominal(100000)"
                          >
                            <div class="nominal">Rp. 100.000</div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 mt-3">
                        <div class="form-group">
                          <label for="email">Nominal Donasi</label>
                          <vue-numeric
                            placeholder="Masukan Nominal"
                            class="form-control"
                            currency="Rp."
                            separator="."
                            v-model="this.nominalSedekah"
                          ></vue-numeric>
                        </div>
                      </div>
                    </div>
                    <center>
                      <a
                        href="javascript:void(0)"
                        class="
                      btn btn-main btn-wide
                      d-block d-md-inline-block
                      mt-32
                    "
                        @click="danaiSekarang('fasilitas-masjed')"
                        >Danai Sekarang</a
                      >
                    </center>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="modal fade program-modal"
        id="modal-program-3"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div
          class="
          modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl
        "
        >
          <div class="modal-content">
            <div class="modal-body">
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-x-lg"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z"
                  />
                </svg>
              </button>
              <div class="row">
                <div class="col-lg-4 valign-wrapper">
                  <div class="valign-box">
                    <img src="/img/img-program-3.svg" />
                  </div>
                </div>
                <div class="col-lg-8 valign-wrapper">
                  <div class="valign-box">
                    <div class="program-subtitle-modal">Program</div>
                    <div class="program-title-modal">Sosial & Keumatan</div>
                    <p class="no-margin">
                      Di program ini kami mengajak masyarakat untuk membantu
                      dalam kegiatan pemberdayaan ekonomi keumatan dan
                      menjadikan masjed sebagai perwujudan beriman, berilmu,
                      beramal sholeh, berkualitas, dan berintegritas sehingga
                      menjadikan masjed sebagai
                      <span class="bold">Centre of Excellence</span>.
                    </p>
                    <div class="row mt-3">
                      <div class="col-12 col-md-12">
                        <div class="form-nominal">
                          <div
                            class="nominal-wrapper"
                            :class="{
                              'is-picked': this.nominalSedekah === 10000,
                            }"
                            @click="setNominal(10000)"
                          >
                            <div class="nominal">Rp. 10.000</div>
                          </div>
                          <div
                            class="nominal-wrapper"
                            :class="{
                              'is-picked': this.nominalSedekah === 20000,
                            }"
                            @click="setNominal(20000)"
                          >
                            <div class="nominal">Rp. 20.000</div>
                          </div>
                          <div
                            class="nominal-wrapper"
                            :class="{
                              'is-picked': this.nominalSedekah === 50000,
                            }"
                            @click="setNominal(50000)"
                          >
                            <div class="nominal">Rp. 50.000</div>
                          </div>
                          <div
                            class="nominal-wrapper"
                            :class="{
                              'is-picked': this.nominalSedekah === 100000,
                            }"
                            @click="setNominal(100000)"
                          >
                            <div class="nominal">Rp. 100.000</div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 mt-3">
                        <div class="form-group">
                          <label for="email">Nominal Donasi</label>
                          <vue-numeric
                            placeholder="Masukan Nominal"
                            class="form-control"
                            currency="Rp."
                            separator="."
                            v-model="this.nominalSedekah"
                          ></vue-numeric>
                        </div>
                      </div>
                    </div>
                    <center>
                      <a
                        href="javascript:void(0)"
                        class="
                      btn btn-main btn-wide
                      d-block d-md-inline-block
                      mt-32
                    "
                        @click="danaiSekarang('sosial-dan-keumatan')"
                        >Danai Sekarang</a
                      >
                    </center>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="modal fade program-modal"
        id="modal-program-4"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div
          class="
          modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl
        "
        >
          <div class="modal-content">
            <div class="modal-body">
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-x-lg"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z"
                  />
                </svg>
              </button>
              <div class="row">
                <div class="col-lg-4 valign-wrapper">
                  <div class="valign-box">
                    <img src="/img/img-program-4.svg" />
                  </div>
                </div>
                <div class="col-lg-8 valign-wrapper">
                  <div class="valign-box">
                    <div class="program-subtitle-modal">Program</div>
                    <div class="program-title-modal">Pemberdayaan Ekonomi</div>
                    <p class="no-margin">
                      Memberdayakan masyarakat di lingkungan masjed untuk
                      mendorong keuangan umat dengan mengajak masyarakat sekitar
                      masjed untuk berpartisipasi dalam usaha serambi masjed.
                    </p>

                    <div class="row mt-3">
                      <div class="col-12 col-md-12">
                        <div class="form-nominal">
                          <div
                            class="nominal-wrapper"
                            :class="{
                              'is-picked': this.nominalSedekah === 10000,
                            }"
                            @click="setNominal(10000)"
                          >
                            <div class="nominal">Rp. 10.000</div>
                          </div>
                          <div
                            class="nominal-wrapper"
                            :class="{
                              'is-picked': this.nominalSedekah === 20000,
                            }"
                            @click="setNominal(20000)"
                          >
                            <div class="nominal">Rp. 20.000</div>
                          </div>
                          <div
                            class="nominal-wrapper"
                            :class="{
                              'is-picked': this.nominalSedekah === 50000,
                            }"
                            @click="setNominal(50000)"
                          >
                            <div class="nominal">Rp. 50.000</div>
                          </div>
                          <div
                            class="nominal-wrapper"
                            :class="{
                              'is-picked': this.nominalSedekah === 100000,
                            }"
                            @click="setNominal(100000)"
                          >
                            <div class="nominal">Rp. 100.000</div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 mt-3">
                        <div class="form-group">
                          <label for="email">Nominal Donasi</label>
                          <vue-numeric
                            placeholder="Masukan Nominal"
                            class="form-control"
                            currency="Rp."
                            separator="."
                            v-model="this.nominalSedekah"
                          ></vue-numeric>
                        </div>
                      </div>
                    </div>
                    <center>
                      <a
                        href="javascript:void(0)"
                        class="
                      btn btn-main btn-wide
                      d-block d-md-inline-block
                      mt-32
                    "
                        @click="danaiSekarang('pemberdayaan-ekonomi')"
                        >Danai Sekarang</a
                      >
                    </center>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="modal fade program-modal"
        id="modal-program-5"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div
          class="
          modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl
        "
        >
          <div class="modal-content">
            <div class="modal-body">
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-x-lg"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z"
                  />
                </svg>
              </button>
              <div class="row">
                <div class="col-lg-4 valign-wrapper">
                  <div class="valign-box">
                    <img src="/img/img-program-5.svg" />
                  </div>
                </div>
                <div class="col-lg-8 valign-wrapper">
                  <div class="valign-box">
                    <div class="program-subtitle-modal">Program</div>
                    <div class="program-title-modal">Pendidikan dan Dakwah</div>
                    <p class="no-margin">
                      Membantu mengembalikan salah satu fungsi masjed yaitu
                      sebagai tempat kegiatan proses belajar mengajar dan
                      membantu masyarakat sekitar masjed untuk memperdalam ilmu
                      agama Islam.
                    </p>

                    <div class="row mt-3">
                      <div class="col-12 col-md-12">
                        <div class="form-nominal">
                          <div
                            class="nominal-wrapper"
                            :class="{
                              'is-picked': this.nominalSedekah === 10000,
                            }"
                            @click="setNominal(10000)"
                          >
                            <div class="nominal">Rp. 10.000</div>
                          </div>
                          <div
                            class="nominal-wrapper"
                            :class="{
                              'is-picked': this.nominalSedekah === 20000,
                            }"
                            @click="setNominal(20000)"
                          >
                            <div class="nominal">Rp. 20.000</div>
                          </div>
                          <div
                            class="nominal-wrapper"
                            :class="{
                              'is-picked': this.nominalSedekah === 50000,
                            }"
                            @click="setNominal(50000)"
                          >
                            <div class="nominal">Rp. 50.000</div>
                          </div>
                          <div
                            class="nominal-wrapper"
                            :class="{
                              'is-picked': this.nominalSedekah === 100000,
                            }"
                            @click="setNominal(100000)"
                          >
                            <div class="nominal">Rp. 100.000</div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 mt-3">
                        <div class="form-group">
                          <label for="email">Nominal Donasi</label>
                          <vue-numeric
                            placeholder="Masukan Nominal"
                            class="form-control"
                            currency="Rp."
                            separator="."
                            v-model="this.nominalSedekah"
                          ></vue-numeric>
                        </div>
                      </div>
                    </div>
                    <center>
                      <a
                        href="javascript:void(0)"
                        class="
                      btn btn-main btn-wide
                      d-block d-md-inline-block
                      mt-32
                    "
                        @click="danaiSekarang('pendidikan-dan-dakwah')"
                        >Danai Sekarang</a
                      >
                    </center>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="modal fade program-modal"
        id="modal-program-6"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div
          class="
          modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl
        "
        >
          <div class="modal-content">
            <div class="modal-body">
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-x-lg"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z"
                  />
                </svg>
              </button>
              <div class="row">
                <div class="col-lg-4 valign-wrapper">
                  <div class="valign-box">
                    <img src="/img/img-program-6.svg" />
                  </div>
                </div>
                <div class="col-lg-8 valign-wrapper">
                  <div class="valign-box">
                    <div class="program-subtitle-modal">Program</div>
                    <div class="program-title-modal">Lingkungan Masjed</div>
                    <p class="no-margin">
                      Program lingkungan masjed ini merupakan kegiatan yang
                      berjuang untuk meningkatkan budaya hidup bersih dan sehat
                      kepada Jama’ah dan masyarakat sekitar masjed serta
                      mendorong terwujudnya pengelolaan sanitasi layak di masjed
                      seluruh Indonesia.
                    </p>

                    <div class="row mt-3">
                      <div class="col-12 col-md-12">
                        <div class="form-nominal">
                          <div
                            class="nominal-wrapper"
                            :class="{
                              'is-picked': this.nominalSedekah === 10000,
                            }"
                            @click="setNominal(10000)"
                          >
                            <div class="nominal">Rp. 10.000</div>
                          </div>
                          <div
                            class="nominal-wrapper"
                            :class="{
                              'is-picked': this.nominalSedekah === 20000,
                            }"
                            @click="setNominal(20000)"
                          >
                            <div class="nominal">Rp. 20.000</div>
                          </div>
                          <div
                            class="nominal-wrapper"
                            :class="{
                              'is-picked': this.nominalSedekah === 50000,
                            }"
                            @click="setNominal(50000)"
                          >
                            <div class="nominal">Rp. 50.000</div>
                          </div>
                          <div
                            class="nominal-wrapper"
                            :class="{
                              'is-picked': this.nominalSedekah === 100000,
                            }"
                            @click="setNominal(100000)"
                          >
                            <div class="nominal">Rp. 100.000</div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 mt-3">
                        <div class="form-group">
                          <label for="email">Nominal Donasi</label>
                          <vue-numeric
                            placeholder="Masukan Nominal"
                            class="form-control"
                            currency="Rp."
                            separator="."
                            v-model="this.nominalSedekah"
                          ></vue-numeric>
                        </div>
                      </div>
                    </div>
                    <center>
                      <a
                        href="javascript:void(0)"
                        class="
                      btn btn-main btn-wide
                      d-block d-md-inline-block
                      mt-32
                    "
                        @click="danaiSekarang('lingkungan-masjed')"
                        >Danai Sekarang</a
                      >
                    </center>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="modal fade program-modal"
        id="modal-program-7"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div
          class="
          modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl
        "
        >
          <div class="modal-content">
            <div class="modal-body">
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-x-lg"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z"
                  />
                </svg>
              </button>
              <div class="row">
                <div class="col-lg-4 valign-wrapper">
                  <div class="valign-box">
                    <img src="/img/img-program-7.svg" />
                  </div>
                </div>
                <div class="col-lg-8 valign-wrapper">
                  <div class="valign-box">
                    <div class="program-subtitle-modal">Program</div>
                    <div class="program-title-modal">Kesejahteraan Masjed</div>
                    <p class="no-margin">
                      Melalui masjed.id dengan Program ini kami mengajak
                      masyarakat untuk mewujudkan masjed yang sejahtera dengan
                      berzakat, berinfaq, dan bersedekah.
                    </p>

                    <div class="row mt-3">
                      <div class="col-12 col-md-12">
                        <div class="form-nominal">
                          <div
                            class="nominal-wrapper"
                            :class="{
                              'is-picked': this.nominalSedekah === 10000,
                            }"
                            @click="setNominal(10000)"
                          >
                            <div class="nominal">Rp. 10.000</div>
                          </div>
                          <div
                            class="nominal-wrapper"
                            :class="{
                              'is-picked': this.nominalSedekah === 20000,
                            }"
                            @click="setNominal(20000)"
                          >
                            <div class="nominal">Rp. 20.000</div>
                          </div>
                          <div
                            class="nominal-wrapper"
                            :class="{
                              'is-picked': this.nominalSedekah === 50000,
                            }"
                            @click="setNominal(50000)"
                          >
                            <div class="nominal">Rp. 50.000</div>
                          </div>
                          <div
                            class="nominal-wrapper"
                            :class="{
                              'is-picked': this.nominalSedekah === 100000,
                            }"
                            @click="setNominal(100000)"
                          >
                            <div class="nominal">Rp. 100.000</div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 mt-3">
                        <div class="form-group">
                          <label for="email">Nominal Donasi</label>
                          <vue-numeric
                            placeholder="Masukan Nominal"
                            class="form-control"
                            currency="Rp."
                            separator="."
                            v-model="this.nominalSedekah"
                          ></vue-numeric>
                        </div>
                      </div>
                    </div>
                    <center>
                      <a
                        href="javascript:void(0)"
                        class="
                      btn btn-main btn-wide
                      d-block d-md-inline-block
                      mt-32
                    "
                        @click="danaiSekarang('kesejahteraan-masjed')"
                        >Danai Sekarang</a
                      >
                    </center>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- New Modal -->
      <div
        class="modal fade program-modal"
        id="modal-berkah-1"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div
          class="
          modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl
        "
        >
          <div class="modal-content">
            <div class="modal-body">
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-x-lg"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z"
                  />
                </svg>
              </button>
              <div class="row">
                <div class="col-lg-4 valign-wrapper">
                  <div class="valign-box">
                    <img src="/img/meraih-cahaya.svg" />
                  </div>
                </div>
                <div class="col-lg-8 valign-wrapper">
                  <div class="valign-box">
                    <div class="program-title-modal">
                      Meraih Cahaya Berkah <br />Dunia & Akhirat
                    </div>
                    <p class="no-margin">
                      Menuntun dalam menjalankan ibadah dan memakmurkan masjed
                      dengan membangun ekosistem masjed sebagai centre of
                      excellence Umat dan meraih cahaya berkahNya Dunia dan
                      Akhirat
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="modal fade program-modal"
        id="modal-berkah-2"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div
          class="
          modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl
        "
        >
          <div class="modal-content">
            <div class="modal-body">
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-x-lg"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z"
                  />
                </svg>
              </button>
              <div class="row">
                <div class="col-lg-4 valign-wrapper">
                  <div class="valign-box">
                    <img src="/img/kegiatan-agama.svg" />
                  </div>
                </div>
                <div class="col-lg-8 valign-wrapper">
                  <div class="valign-box">
                    <div class="program-title-modal">
                      Fitur-fitur kegiatan Agama
                    </div>
                    <p class="no-margin">
                      Memudahkan asatidz untuk menyebarluaskan dakwah, tablig,
                      dan khutbah ataupun kajian kepada jama’ah dimanapun
                      berada.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Berkah 3 -->
      <div
        class="modal fade program-modal"
        id="modal-berkah-3"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div
          class="
          modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl
        "
        >
          <div class="modal-content">
            <div class="modal-body">
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-x-lg"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z"
                  />
                </svg>
              </button>
              <div class="row">
                <div class="col-lg-4 valign-wrapper">
                  <div class="valign-box">
                    <img src="/img/keuangan-dkm.svg" />
                  </div>
                </div>
                <div class="col-lg-8 valign-wrapper">
                  <div class="valign-box">
                    <div class="program-title-modal">
                      Kemudahan <br class="d-none d-md-block" />
                      Pelaporan Keuangan <br class="d-none d-md-block" />
                      DKM Masjed.
                    </div>
                    <p class="no-margin">
                      Memudahkan DKM masjed dalam pembuatan laporan
                      Pertanggungjawaban keuangan kegiatan masjed.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Berkah 4 -->
      <div
        class="modal fade program-modal"
        id="modal-berkah-4"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div
          class="
          modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl
        "
        >
          <div class="modal-content">
            <div class="modal-body">
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-x-lg"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z"
                  />
                </svg>
              </button>
              <div class="row">
                <div class="col-lg-4 valign-wrapper">
                  <div class="valign-box">
                    <img src="/img/serambi-masjid.svg" />
                  </div>
                </div>
                <div class="col-lg-8 valign-wrapper">
                  <div class="valign-box">
                    <div class="program-title-modal">
                      Ikutserta dalam <br class="d-none d-md-block" />
                      Usaha Serambi <br class="d-none d-md-block" />
                      Masjed.
                    </div>
                    <p class="no-margin">
                      Meningkatkan produktifitas dalam mengikuti program
                      pemberdayaan dan ekonomi keumatan dan menjadi bagian dari
                      yang beriman, berilmu, beramal sholeh, berkualitas, dan
                      berintegritas.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Berkah 5 -->
      <div
        class="modal fade program-modal"
        id="modal-berkah-5"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div
          class="
          modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl
        "
        >
          <div class="modal-content">
            <div class="modal-body">
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-x-lg"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z"
                  />
                </svg>
              </button>
              <div class="row">
                <div class="col-lg-4 valign-wrapper">
                  <div class="valign-box">
                    <img src="/img/sedekah-online.svg" />
                  </div>
                </div>
                <div class="col-lg-8 valign-wrapper">
                  <div class="valign-box">
                    <div class="program-title-modal">
                      Transaksi Infaq, <br class="d-none d-md-block" />
                      Zakat dan <br class="d-none d-md-block" />
                      Sedekah Online.
                    </div>
                    <p class="no-margin">
                      memberikan kemudahan, kenyamanan, dan kemudahan dalam
                      melakukan kegiatan Zakat, Infaq, Sedekah, dan Wakaf secara
                      digital.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import axios from "../utils/api";
import $ from "jquery";
import carousel from "vue-owl-carousel";
import Layout from "../views/layouts/Index.vue";
import { mapActions } from "vuex";
import VueNumeric from "vue-numeric";

export default {
  name: "beranda",
  data() {
    return {
      responsive: {
        0: {
          stagePadding: 20,
          items: 1,
        },
        600: {
          stagePadding: 50,
          items: 2,
        },
        1140: {
          stagePadding: 140,
          items: 2,
        },
      },
      link: {
        // program: 'https://masjed.id/app/site/index',
        // carimasjid: 'https://masjed.id/app/site/index',
        // zuhra: 'https://masjed.id/app/site/index',
        // cahayamasjid: 'https://masjed.id/app/site/index',
        program: "/program",
        carimasjid: "/cari-masjid",
        zuhra:
          "/donasi-baju-baru/ayo-wujudkan-baju-baru-untuk-1000-yatim-piatu",
        cahayamasjid: "/program/sejuta-cahaya-masjed",
      },
      fitur: [
        {
          id: 1,
          image: "img/icons/jadwal_sholat_icon.svg",
          title: "Jadwal Sholat",
          route: "https://masjed.id/app/jadwalsholat",
        },
        {
          id: 2,
          image: "img/icons/arah_kiblat_icon.svg",
          title: "Arah Kiblat",
          route: "https://masjed.id/app/arahkiblat/index",
        },
        {
          id: 3,
          image: "img/icons/alquran_icon.svg",
          title: "Al-Qur'an",
          route: "https://masjed.id/app/alquran",
        },
        {
          id: 4,
          image: "img/icons/carimasjed_icon.svg",
          title: "Cari Masjed",
          route: "https://masjed.id/app/masjid",
        },
        {
          id: 5,
          image: "https://masjed.id/app/template/img/icons/pulsa.svg",
          title: "Pulsa & Data",
          route: "https://masjed.id/app/ppob/pulsa",
        },
        {
          id: 6,
          image: "img/icons/infaq_sedekah_icon.svg",
          title: "Infaq & Sedekah",
          route: "https://masjed.id/app/sedekah/create",
        },
        {
          id: 7,
          image: "img/icons/emoney_icon.svg",
          title: "Top Up E-Money",
          route: "https://masjed.id/app/ppob/topupwallet",
        },
        {
          id: 8,
          image: "img/icons/pln_icon.svg",
          title: "PLN",
          route: "https://masjed.id/app/ppob/pln",
        },
      ],
      osDevice: null,
      osBrowser: null,
      nominalSedekah: 0,
    };
  },
  components: {
    Layout,
    carousel,
    VueNumeric,
  },
  methods: {
    ...mapActions("transactions", ["resetForm", "setInitialTransaction"]),
    setNominal(val) {
      this.nominalSedekah = val;
    },
    async danaiSekarang(title) {
      const detail = await axios.get(
        `/detailcampaign?slug=sejuta-cahaya-masjed`
      );
      const { campaign } = detail.data.data;

      const payload = {
        program: {
          programId: campaign.id || "",
          programTitle: campaign.title || "",
          nominalDonasi: this.nominalSedekah,
        },
        user: {
          namaDonatur: "Hamba Allah",
          emailDonatur: "deddy@dompetdhuafa.org",
          teleponDonatur: "08118625234",
          doaDonatur: "Bismillah, Semoga Berkah.",
        },
      };

      this.setInitialTransaction(payload);

      location.href = `/pembayaran-custom/${title}`;
    },
    isMobile() {
      if (screen.width <= 760) {
        return true;
      } else {
        return false;
      }
    },
    cekDevice() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;

      if (/windows phone/i.test(userAgent)) {
        this.osDevice = "windows_phone";
      }

      if (/android/i.test(userAgent)) {
        this.osDevice = "android";
      }

      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        this.osDevice = "ios";
      }

      if (/Mac/i.test(userAgent)) {
        this.osDevice = "macos";
      }

      if (/Windows/i.test(userAgent)) {
        this.osDevice = "windowsos";
      }
    },
    cekBrowser() {
      if (navigator.userAgent.includes("Safari")) {
        this.osBrowser = "safari";
      }
      if (navigator.userAgent.indexOf("Chrome")) {
        this.osBrowser = "chrome";
      }
      if (navigator.userAgent.includes("Opera")) {
        this.osBrowser = "opera";
      }
      if (navigator.userAgent.includes("Firefox")) {
        this.osBrowser = "firefox";
      }
    },
    openFitur(url) {
      window.open(url, "_self");
    },
  },
  mounted() {
    this.resetForm();
    this.cekBrowser();
    this.nominalSedekah = 10000;
  },
  created() {
    if (!this.isMobile()) {
      this.link = {
        program: "/program",
        carimasjid: "/cari-masjid",
        zuhra:
          "/donasi-baju-baru/ayo-wujudkan-baju-baru-untuk-1000-yatim-piatu",
        cahayamasjid: "/program/hadirkan-cahaya-masjed",
      };
    }
  },
};
</script>

<style>
@media only screen and (max-width: 320px) {
  .colom-masjed-fitur {
    padding-top: 585px !important;
  }
  .style-header-new {
    height: 700px !important;
  }
  .img-fitur {
    width: 4vh;
    height: 4vh;
  }
  .title-fitur-size {
    font-size: 10px;
    text-align: center;
  }
  #mobile-view {
    display: block;
  }
  #web-view {
    display: none;
  }
  .img-style-new {
    width: 100px !important;
    height: 60px !important;
    margin-top: 16px;
  }
  .welcome-text-new {
    font-size: 2vh !important;
    padding-top: 45px;
  }
  .bg-header {
    object-fit: cover;
    background-repeat: no-repeat;
    background-size: 180% 100% !important;
    background-position: -200px 0 !important;
  }
}

@media only screen and (min-width: 321px) and (max-width: 375px) {
  #mobile-view {
    display: block;
  }
  #web-view {
    display: none;
  }
  .img-style-new {
    width: 13vh;
    height: 9vh;
    margin-top: 8px !important;
  }
  .welcome-text-new {
    font-size: 2.7vh !important;
    padding-top: 38px;
  }
  .colom-masjed-fitur {
    padding-top: 540px !important;
  }
  .bg-header {
    background: #ffffff;
    object-fit: cover;
    background-repeat: no-repeat;
    background-size: 160% 100% !important;
    background-position: -180px 0 !important;
  }
}

@media only screen and (min-width: 376px) and (max-width: 480px) {
  #mobile-view {
    display: block;
  }
  #web-view {
    display: none;
  }
  .img-style-new {
    width: 15vh;
    height: 11vh;
    margin-top: 8px;
  }
  .colom-masjed-fitur {
    padding-top: 540px !important;
  }
  .welcome-text-new {
    font-size: 3vh !important;
    padding-top: 50px;
  }
  .bg-header {
    background: #ffffff;
    object-fit: cover;
    background-repeat: no-repeat;
    background-size: 140% 100% !important;
    background-position: -150px 0 !important;
  }
}

@media only screen and (min-width: 481px) and (max-width: 768px) {
  #mobile-view {
    display: block;
  }
  #web-view {
    display: none;
  }
  /* #container{
      width: 1000px;
    } */
  .img-style-new {
    width: 22vh;
    height: 22vh;
  }
  .welcome-text-new {
    font-size: 4vh !important;
    padding-top: 80px;
  }
  .bg-header {
    background: #ffffff;
    object-fit: cover;
    background-repeat: no-repeat;
    background-size: 100% 140% !important;
    background-position: 0 -160px !important;
  }
  .colom-masjed-fitur {
    padding-top: 560px !important;
  }
}

.navbar-brandnew .text-brandnew {
  font-size: 12px;
  line-height: 12px;
  color: #ffffff;
  display: inline-block;
  vertical-align: bottom;
  text-transform: capitalize;
  font-weight: 700;
}

.img-playstore,
.img-appstore {
  margin: 0px 15px;
  width: 200px !important;
}
</style>
